import "../../styles/visualization/visualizationTheory.css";
import { formatTheory } from "../../utils/formatTheory.js";

const VisualizationTheory = ({ theory }) => {
  if (!theory) return null;

  return (
    <section className="viz-theory">
      <h2 className="viz-theory-title">Theory</h2>

      <div
        className="viz-theory-content"
        dangerouslySetInnerHTML={{ __html: formatTheory(theory) }}
      />
    </section>
  );
};

export default VisualizationTheory;
